export const GET_LIST_CONGNOTHANHLY = "GET_LIST_CONGNOTHANHLY";
export const GET_LIST_CONGNOTHANHLY_SUCCESS = "GET_LIST_CONGNOTHANHLY_SUCCESS";
export const GET_LIST_CONGNOTHANHLY_FAILURE = "GET_LIST_CONGNOTHANHLY_FAILURE";

export const UPDATE_SEARCHTDATA_CONGNOTHANHLY =
  "UPDATE_SEARCHTDATA_CONGNOTHANHLY";
